<template>
  <div class="template-form">
    <div class="layout">
      <back-button class="back-button" caption="ย้อนกลับ" />
    </div>

    <div class="template-body">
      <div class="topic-wrapper">
        <div class="template-title">
          <h3>{{ title }}</h3>
          <div>
            {{ description }}
            <slot name="link"></slot>
            <slot name="remark"></slot>
          </div>
        </div>
      </div>
      <div class="slot-wrapper">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TemplateForm",
  props: ["isBack", "title", "description"],
};
</script>

<style scoped>
.template-form {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  min-height: calc(896px - 136px);
}
.template-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  position: relative;
}
.topic-wrapper {
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 0px 30px;

  width: 100%;
  max-width: 1120px;
  box-sizing: border-box;
}

.template-title {
  width: 100%;
  border-bottom: 1px solid #acb1bf;
  margin-bottom: 24px;
  padding-bottom: 16px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  text-align: left;
}
.slot-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  text-align: left;
  width: 100%;
  max-width: 1120px;
  box-sizing: border-box;

  min-height: 500px;
}
.slot-body {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  /* max-width: 352px; */
}
.layout {
  width: 100%;
  padding: 0px 30px;
  max-width: 1120px;
  box-sizing: border-box;
}
.back-button {
  margin: 24px 0;
}

/*size  >768px */
@media only screen and (min-width: 769px) {
  .back-button {
    margin-bottom: 0;
  }
  .topic-wrapper {
    flex-direction: row;
    position: relative;
    padding: 0;
  }
  .template-title {
    align-items: center;
  }

  .layout {
    padding: 0 20px;
  }
}
</style>
